export default {
    clientInbox: {
        subtitle:
            'Client Inbox Documents are visible for 1 year after receiving. <0>Users that currently have access to this Inbox.</0>',
        title: 'Client Inbox',
        userListPopup: {
            edit: 'Edit',
            footer: 'Please contact {{ partnerName }} if you wish to make edits to this list.',
            heading: 'Current users of this inbox:',
        },
    },
    clientInboxItem: {
        bizpayPanel: {
            description:
                'Company or sole proprietor? Pay bank transfer invoices by credit card using one of our partners.*',
            disclaimer:
                '* Requires registration and approval by the third-party service.',
            linkText: 'Go to <0 className="ml-2"></0>', // The EN version needs this left margin
            title: 'Pay invoice by credit card',
        },
        cancelled: 'This document was cancelled by the sender.',
        infoPanel: {
            download: 'Download',
            title: 'Overview',
            view: 'View',
            zipExplanation:
                'This file is provided as uploaded by {{ partnerName }}. MakeLeaps staff are unable to answer any inquiries regarding its contents etc.<0></0><0></0>Furthermore, this file has not been checked for viruses etc, so if you are not expecting this file or do not know the sender, please do not download.',
            zipTitle: '{{ partnerName }} has sent you a ZIP file',
        },
        loginToMakeLeaps: {
            login: 'MakeLeaps user? <0>Login</0>',
            salesForce:
                'MakeLeaps for Salesforce users cannot use the above login.',
        },
        payPanel: {
            autoChargeEnabledMessage:
                'Your card will be saved, and can automatically be used for future invoices from this company.',
            button: 'Pay',
            errorMessages: {
                generic:
                    'There seems to be something wrong with our payment system at the moment, please try again in a couple of minutes. If this problem persists, please contact us at support@makeleaps.com',
                timeout:
                    'Our payment systems seem to be overloaded at the moment. Please try again in a couple of minutes. If the problem persists, please contact us at support@makeleaps.com',
            },
            paid: 'Paid',
            paymentTotal: 'Payment Total',
            successMessage: 'Your payment was successful! Thank you!',
            title: 'Pay',
        },
        returnToClientInbox: 'Back to Client Inbox',
    },
    clientInboxUsers: {
        cardEditSubtext: 'Input at least one email address',
        cardTitle: 'Client Inbox',
        fieldLabel: 'Client Inbox Users',
        fieldTooltip:
            'The email addresses which receive activity notifications and can access the Client Inbox',
        formErrorEmailDuplicate: 'Each email address can only be used once.',
        information:
            'Please contact {{ partnerName }} if you wish to make edits to this list.',
        viewSubtitle:
            'Settings for this Portal, provided by {{ partnerName }}. Some settings may be editable if the provider has given you permission.',
        viewTitle: 'Settings',
        warningEnd: 'Are you sure you want to remove {{ email }}?',
        warningExplanation1:
            'it will no longer receive notifications from and lose access to this Client Inbox.',
        warningExplanation2:
            'this Client Inbox session will be logged out <0>immediately</0>.',
        warningStart: 'By removing the email address {{ email }}, ',
        warningSubmit: 'Remove and Logout',
        warningTitle: 'Remove the logged-in User?',
    },
    downloadDocumentModal: {
        cancel: 'Cancel',
        download: 'Preparing download of {{numberOfItems}} Documents..',
        downloadBody:
            'The selected Documents will be compressed into a ZIP file and then the download will begin. This message will close automatically after download.',
        downloadLink: 'Download',
        error: 'An error occurred. Please try again later.',
        includesZipFile:
            'Caution: ZIP files are as uploaded by MakeLeaps users. Learn more in the <0>Business Portals Manual</0>.',
    },
    edit: 'Edit',
    filters: {
        all: 'All',
        clear: 'Reset search',
        documentStatus: 'Status',
        documentStatuses: {
            all: 'All',
            cancelled: 'Cancelled',
            inaccessible: 'Retracted',
            valid: 'Valid',
        },
        documentType: 'Type',
        documentTypeTooltip:
            'MakeLeaps Standard Document Type (may not match title)',

        receivedDate: 'Received',
        searchTerms: 'Search',
        searchTermsTooltip: 'Searches "Document" and "Project" columns',
    },
    footer: {
        aboutMl: 'About MakeLeaps',
        portalManual: 'Portal Manual',
        poweredBy: 'Powered by',
    },
    home: {
        subtitle: 'List of Business Portals for',
    },
    inbox: {
        action: 'Actions',
        addToSecureInbox: 'Add to Inbox',
        addToSecureInboxTitle: 'Add to MakeLeaps Secure Inbox',
        addressee: 'Attention',
        cancelled: 'Cancelled by Sender',
        company: 'Company',
        displayName: 'Document',
        documentNumber: 'Document',
        documentType: 'Type',
        documentTypeTooltip:
            'MakeLeaps Standard Document Type (may not match title)',
        download: 'Download',
        downloadSelection: 'Download Selection',
        downloadSelectionDisabledReason:
            'Please select at least two documents to download.',
        fileSize: 'File Size',
        inaccessible: 'Retracted by Sender',
        jst: 'JST',
        noDocuments:
            "No documents to display. You either haven't received any Documents recently, or your search terms are too strict.",
        paid: 'Paid',
        pay: 'Pay...',
        pdfPanelTitle: '{{ documentType }} sent to you by {{ partnerName }}',
        preview: 'Preview etc...',
        projectName: 'Project',
        received: 'Received',
        receivedWithTime: 'Received',
        return: 'Return to List of Business Portals',
        seeDetails: 'See Details',
        total: 'Total',
        unsupportedDocument: 'This document type is not supported.',
        view: 'View',
    },
    login: {
        closeTab: 'Close Tab',
        email: 'Email Address',
        faqAnswer1:
            '"Business Portals by MakeLeaps" is the place where you can interact with your business partners that are MakeLeaps users, starting with access to the history of invoices or other documents and files sent to you.',
        faqAnswer2:
            "Please check our <0>Business Portals Manual</0> first, which has a special section for troubleshooting.<1></1>If you're still having issues, <2>please contact your business partner</2> who is a MakeLeaps user. (MakeLeaps support is only available to contracted users, so we will not be able to assist you directly. Thank you for your understanding.)",
        faqAnswer3:
            'MakeLeaps is a cloud-based invoice management service, allowing its users to create and send business documents to their Clients.<0></0><0></0>For more details, see our <1>web page (Japanese)</1>.',
        faqAnswer4:
            'Only email addresses that are configured by MakeLeaps users as Portal Users can log in, and we authorize those Portal Users by sending a unique login link only to the registered email address.<0></0><0></0>More details about security can be found in the <1>Business Portals Manual</1>.',
        faqQuestion1: 'What is "Business Portals by MakeLeaps"?',
        faqQuestion2:
            'What should I do if I have questions or am seeing an error?',
        faqQuestion3: 'What is MakeLeaps?',
        faqQuestion4: 'How are Business Portals secured?',
        faqTitle: 'FAQ',
        linkExpirationWarning:
            'Login Links expire 10 minutes after they are sent.',

        login: 'Log in using a different email address',
        partnerSubtitle:
            '<0>{{ partnerName }}</0> has Documents for you in their Client Inbox. Request a login link below. ',
        portalLink: 'Business Portals User Manual',
        rememberMe: 'Remember Me',
        submit: 'Send Login Link',
        subtitle:
            'To access your Business Portals, please input your business email address here to receive a Login Link:',
        successMessage:
            'If a MakeLeaps user has a Business Portal set up for {{email}}, you will receive a Login Link to that address in a few moments.',
        successTitle: 'Please check your email',
        title: 'Welcome to Business Portals by MakeLeaps',
        troubleshootingDomain:
            'Check your email server is not blocking emails from the makeleaps.com domain.',
        troubleshootingEmail: 'Confirm you typed your email address correctly.',
        troubleshootingPersonalEmail:
            'Please check that your business partner has your email address and other Business Portal settings correct.',
        troubleshootingSpam: "Check your email account's spam folder.",
        troubleshootingTitle: "Didn't get an email?",
        tryAgain: 'Try Again',
        webPageLink: 'web page',
    },
    logout: 'Logout',
    notifications: {
        badLinkToken:
            'The Login Link you used is expired or otherwise invalid. Please request another link below.',
        expiredSessionToken:
            'Your session has expired. To access your portal again, please request a new Login Link below.',
        invalidSessionToken:
            'We were not able to confirm your session details. Please request a new login link below.',
        loggedOut: 'You have logged out. Thank you for using Business Portals.',
        missingSessionToken:
            'The page you are trying to access requires a login. Please request a Login Link below.',
        portalNotAvailable:
            "The link you have accessed either doesn't exist or isn't available for the logged-in email address. Please confirm the link's URL.",
    },
    personalInbox: {
        subtitle: 'All items sent to the address {{email}}',
        title: 'Personal Inbox',
    },
    resend: {
        error: 'Please try again',
        init: 'Resend link',
        requested: 'Resending...',
        success: 'Link resent',
    },
    sessionCustomExpiration: '{{ sessionMinutes }} min.',
    sessionTimer: {
        expired: 'The session is expired',
        expiry: 'Session expires in {{hours}} hours {{minutes}} minutes',
        expiryMinutesOnly: 'Session expires in {{minutes}} minutes',
        expirySecondsOnly: 'Session expires in {{seconds}} seconds',
    },
    signOffDocumentModal: {
        cancel: 'Cancel',
        cancelled: 'This document was cancelled by the sender.',
        confirmation: {
            accepted:
                'This document was accepted, and the sender has been notified. Thank you.',
            header: 'Sign Off on this document',
            info: 'To sign off on this document, please write your name. The sender will be notified that you accepted.',
            ownDocument: "You cannot sign off on your own company's documents.",
            signOff: 'Sign Off',
            signerInput: 'Signer',
            title: 'Sign Off',
        },
        noteInput: 'Message',
        order: {
            accepted:
                'This document was accepted, and the sender has been notified. Thank you.',
            header: 'Sign Off on this document',
            info: 'To sign off on this document, please write your name. The sender will be notified that you accepted.',
            ownDocument: "You cannot sign off on your own company's documents.",
            signOff: 'Sign Off',
            signerInput: 'Signer',
            title: 'Sign Off',
        },
        total: 'Document Total',
    },
};
